import { CustomerAppAppearanceOptionsVoData } from "../..";
var CustomerPortalAppearanceOptionsConverter = /** @class */ (function () {
    function CustomerPortalAppearanceOptionsConverter() {
    }
    CustomerPortalAppearanceOptionsConverter.convertCustomerPortalAppearanceOptionsToVo = function (appearanceOptionsApiData) {
        if (appearanceOptionsApiData == null || appearanceOptionsApiData == undefined) {
            return null;
        }
        var appearanceOptionsVoData = new CustomerAppAppearanceOptionsVoData(appearanceOptionsApiData.id);
        appearanceOptionsVoData.mainColor = appearanceOptionsApiData.mainColor;
        appearanceOptionsVoData.bodyColor = appearanceOptionsApiData.bodyColor;
        appearanceOptionsVoData.mainBGColor = appearanceOptionsApiData.mainBGColor;
        appearanceOptionsVoData.menuBGColor = appearanceOptionsApiData.menuBGColor;
        appearanceOptionsVoData.mainTextColor = appearanceOptionsApiData.mainTextColor;
        appearanceOptionsVoData.secondaryButtonTextColor = appearanceOptionsApiData.secondaryButtonTextColor;
        appearanceOptionsVoData.secondaryButtonColor = appearanceOptionsApiData.secondaryButtonColor;
        appearanceOptionsVoData.langKey = appearanceOptionsApiData.langKey;
        appearanceOptionsVoData.customLangFileId = appearanceOptionsApiData.customLangFileId;
        appearanceOptionsVoData.showBranding = appearanceOptionsApiData.showBranding;
        appearanceOptionsVoData.showCustomerApp = appearanceOptionsApiData.showCustomerApp;
        appearanceOptionsVoData.useLogo = appearanceOptionsApiData.useLogo;
        appearanceOptionsVoData.useFrom = appearanceOptionsApiData.useFrom;
        appearanceOptionsVoData.logoFileKey = appearanceOptionsApiData.logoFileKey;
        appearanceOptionsVoData.smallBubbleMessage = appearanceOptionsApiData.smallBubbleMessage;
        appearanceOptionsVoData.botImageUrl = appearanceOptionsApiData.botImageUrl;
        appearanceOptionsVoData.botName = appearanceOptionsApiData.botName;
        return appearanceOptionsVoData;
    };
    return CustomerPortalAppearanceOptionsConverter;
}());
export { CustomerPortalAppearanceOptionsConverter };
//# sourceMappingURL=customer-portal-appearance-options-converter.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/utils/converter/customer-portal-appearance-options-converter.js
// module id = 962
// module chunks = 14